/**
 * The failure reasons the backend puts on /auth/error?reason=… .
 *
 * Kept in one place, and in one order, so the i18n keys can be checked
 * against it (authError.test.ts): a reason with no translation renders as a
 * raw key on the one screen a stuck parent actually reads.
 * Source of truth: memoneo `backend/app/routers/auth.py`, the three
 * RedirectResponse(/auth/error) call sites of `verify_magic_link`.
 */
export const AUTH_ERROR_REASONS = [
  "invalid_token",
  "inactive_account",
  "invalid_oauth_session",
] as const;

export type AuthErrorReason = (typeof AUTH_ERROR_REASONS)[number] | "unknown";

/** Anything we don't recognise — a truncated link, a hand-typed URL — gets
 * the generic message rather than a blank card. */
export function parseAuthErrorReason(raw: string | null | undefined): AuthErrorReason {
  return AUTH_ERROR_REASONS.includes(raw as (typeof AUTH_ERROR_REASONS)[number])
    ? (raw as AuthErrorReason)
    : "unknown";
}
